import { IDictionary } from '@interfaces';
import { createAction, props } from '@ngrx/store';

export const loadDictionary = createAction('[Dictionary] Load Dictionary');
export const loadDictionarySuccess = createAction(
  '[Dictionary] Load Dictionary Success',
  props<{ dictionary: IDictionary[] }>(),
);
